import { defineStore } from 'pinia'
import { useAppStore } from './appStore'
import { useToast } from 'vuestic-ui'
import { api } from '../services/api'

export const useReportStore = defineStore('report', {
  state: () => ({
    data: null as null | {
      total_customers: number
      account_complete_count: number
      account_complete_percentage: number
      telemedicine_count: number
      presencial_count: number
      busiest_day_of_week: string | null
      products: { name: string; count: number }[]
      chart_per_day: Record<string, number>
      chart_per_weekday: Record<string, { day_number: number; day_name_pt: string; count: number }>
    },
  }),

  actions: {
    async getDashboard(month: number, year: number) {
      const appStore = useAppStore()

      appStore.toggleLoading(true)

      try {
        const { data } = await api.get('/tenant/dashboard', {
          params: { month, year },
        })

        this.data = data.data
      } catch (e: any) {
        const { init } = useToast()
        if (e?.response?.data?.message) {
          init({ message: e.response.data.message, color: 'danger' })
        } else {
          init({ message: e.message, color: 'danger' })
        }
      } finally {
        appStore.toggleLoading(false)
      }
    },
  },
})
